import styled from "styled-components";
import { CgEye } from "react-icons/cg";
import { Check, Close } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { Avatar, Grid, IconButton, Tooltip } from "@mui/material";

import SortBy from "./SortBy";
import pages from "../../../constants/pages";
import { Chip, Search } from "../../../components";
import MuiTable from "../../../components/MuiTable";
import { colors, HeadingEighteen } from "../../css components/Style";
import Categorize from "../../campaign components/campaign list components/superadmin list components/Categorize";

const Icon = styled(IconButton)`
  border: 1px solid ${colors.purple} !important;
  color: ${colors.purple} !important;
  height: 35px;
  width: 35px;
  margin: 0 5px;
  padding: 0 5px;
  &:hover {
    border: 1px solid ${colors.purple} !important;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }
`;

const CheckIcon = styled(Check)`
  color: #28967e;
  border-radius: 5px;
  border: 3px solid;
  font-size: x-large;
  margin-top: 5px;
`;

const CloseIcon = styled(Close)`
  color: #d32f2f;
  border-radius: 5px;
  border: 3px solid;
  font-size: x-large;
  margin-top: 5px;
`;

export default function List({
  agencies,
  setPage,
  setSearchKey,
  loading,
  sortList,
  sortBy,
  setSortBy,
  categorize,
  setCategorize,
}) {
  const { state } = useLocation();

  function handleAgencyNavigation(agencyID) {
    if (state?.component === "platform") {
      navigate(
        pages.unverifiedPage.route +
          "?agencyID=" +
          agencyID +
          "&platformID=" +
          categorize,
        {
          state: { component: state?.component },
        }
      );
    } else {
      navigate(pages.unverifiedAgenciesDetails.route + "?agencyID=" + agencyID);
    }
  }

  const navigate = useNavigate();
  let columns = [
    { name: "", label: "" },
    { name: "agency_name", label: "Agency Name" },

    {
      name: "agency_verification_status",
      label: "Agency Status",
    },
    {
      name: "platform_source",
      label: "Platform Source",
    },
    {
      name: "api_partner",
      label: "API Partner",
    },
    { name: "is_company_detail_filled", label: "Company Details" },
    { name: "is_sign_agreement", label: "Agreement Signed" },

    {
      name: "action",
      label: "Action",
    },
  ];

  const renderCell = (col, value, row) => {
    if (col.name === "") {
      return (
        <Avatar
          src={row.logo}
          style={{ height: "40px", width: "40px", cursor: "pointer" }}
        />
      );
    }

    if (col.name === "is_company_detail_filled") {
      return (
        <HeadingEighteen
          style={{
            color:
              row.is_company_detail_filled === 0 ? colors.yellow : colors.green,
          }}
        >
          {row.is_company_detail_filled === 1 ? (
            <CheckIcon
              sx={{
                marginLeft: "45px",
              }}
            />
          ) : (
            <CloseIcon
              sx={{
                marginLeft: "45px",
              }}
            />
          )}
        </HeadingEighteen>
      );
    }

    if (col.name === "is_sign_agreement") {
      return (
        <HeadingEighteen
          style={{
            color:
              row.is_sign_agreement === false ? colors.yellow : colors.green,
          }}
        >
          {row.is_sign_agreement === true ? (
            <CheckIcon
              sx={{
                marginLeft: "55px",
              }}
            />
          ) : (
            <CloseIcon
              sx={{
                marginLeft: "55px",
              }}
            />
          )}
        </HeadingEighteen>
      );
    }

    if (col.name === "agency_verification_status") {
      let color;
      let label;
      let background;
      if (value === 0) {
        color = colors.warning;
        background = colors.lightWarning;
        label = "Unverified";
      }

      if (value === 1) {
        color = colors.success;
        background = colors.lightSuccess;
        label = "Verified";
      }

      if (value === 2) {
        color = colors.error;
        background = colors.lightError;
        label = "Rejected";
      }

      return (
        <Chip
          style={{
            fontSize: "13px",
            backgroundColor: background,
            color: color,
          }}
          label={label}
        />
      );
    }

    if (col.name === "action") {
      return (
        <div>
          <Tooltip title="View Agency">
            <Icon>
              <CgEye
                onClick={() => handleAgencyNavigation(row.agency_id)}
                style={{ height: "20px", width: "20px" }}
              />
            </Icon>
          </Tooltip>
        </div>
      );
    }

    return value; // default
  };

  return (
    <Grid container spacing={8}>
      <Grid size={12} />
      <Grid size={12}>
        <MuiTable
          loading={loading}
          components={[
            <ToolBar
              categorize={categorize}
              setCategorize={setCategorize}
              sortList={sortList}
              sortBy={sortBy}
              setPage={setPage}
              setSortBy={setSortBy}
              setSearchKey={setSearchKey}
            />,
          ]}
          columns={columns}
          renderCell={renderCell}
          data={agencies}
        />
      </Grid>
    </Grid>
  );
}

export function ToolBar({
  setPage,
  setSearchKey,
  sortList,
  sortBy,
  setSortBy,
  categorize,
  setCategorize,
}) {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <div style={{ display: "flex", gap: "10px" }}>
        <Search setPage={setPage} setSearchKey={setSearchKey} />

        <Categorize
          categorize={categorize}
          setCategorize={setCategorize}
          setPage={setPage}
        />

        <SortBy
          sortList={sortList}
          sortBy={sortBy}
          setPage={setPage}
          setSortBy={setSortBy}
        />
      </div>
    </div>
  );
}
